/* eslint-disable */
// @ts-nocheck
// source: internal/tax_refund_methods.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var shared_types_physical_address_pb = require('../shared/types/physical_address_pb.js');
goog.object.extend(proto, shared_types_physical_address_pb);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.BankAccountType', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.displayName = 'proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ownerUserId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    refundType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    deliveryMethod: (f = msg.getDeliveryMethod()) && proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.toObject(includeInstance, f),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod;
  return proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerUserId(value);
      break;
    case 5:
      var value = /** @type {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType} */ (reader.readEnum());
      msg.setRefundType(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.deserializeBinaryFromReader);
      msg.setDeliveryMethod(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOwnerUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRefundType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDeliveryMethod();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string owner_user_id = 4;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getOwnerUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setOwnerUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional TaxRefundType refund_type = 5;
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getRefundType = function() {
  return /** @type {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setRefundType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TaxRefundDeliveryMethod delivery_method = 6;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getDeliveryMethod = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod, 6));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setDeliveryMethod = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.clearDeliveryMethod = function() {
  return this.setDeliveryMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.hasDeliveryMethod = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp create_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp update_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundMethod.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.TypeCase = {
  TYPE_NOT_SET: 0,
  CHECK: 1,
  DIRECT_DEPOSIT: 2,
  FUTURE_TAX_CREDIT: 3
};

/**
 * @return {proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.TypeCase}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    check: (f = msg.getCheck()) && proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.toObject(includeInstance, f),
    directDeposit: (f = msg.getDirectDeposit()) && proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.toObject(includeInstance, f),
    futureTaxCredit: (f = msg.getFutureTaxCredit()) && proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod;
  return proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.deserializeBinaryFromReader);
      msg.setCheck(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.deserializeBinaryFromReader);
      msg.setDirectDeposit(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.deserializeBinaryFromReader);
      msg.setFutureTaxCredit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheck();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.serializeBinaryToWriter
    );
  }
  f = message.getDirectDeposit();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.serializeBinaryToWriter
    );
  }
  f = message.getFutureTaxCredit();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional CheckTaxRefundDeliveryMethod check = 1;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.getCheck = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod, 1));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.setCheck = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.clearCheck = function() {
  return this.setCheck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.hasCheck = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DirectDepositTaxRefundDeliveryMethod direct_deposit = 2;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.getDirectDeposit = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod, 2));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.setDirectDeposit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.clearDirectDeposit = function() {
  return this.setDirectDeposit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.hasDirectDeposit = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FutureTaxCreditTaxRefundDeliveryMethod future_tax_credit = 3;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.getFutureTaxCredit = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod, 3));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.setFutureTaxCredit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.clearFutureTaxCredit = function() {
  return this.setFutureTaxCredit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.prototype.hasFutureTaxCredit = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    mailingAddress: (f = msg.getMailingAddress()) && shared_types_physical_address_pb.PhysicalAddress.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod;
  return proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_physical_address_pb.PhysicalAddress;
      reader.readMessage(value,shared_types_physical_address_pb.PhysicalAddress.deserializeBinaryFromReader);
      msg.setMailingAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMailingAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_physical_address_pb.PhysicalAddress.serializeBinaryToWriter
    );
  }
};


/**
 * optional worklayer.internal.v1.PhysicalAddress mailing_address = 1;
 * @return {?proto.worklayer.internal.v1.PhysicalAddress}
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.prototype.getMailingAddress = function() {
  return /** @type{?proto.worklayer.internal.v1.PhysicalAddress} */ (
    jspb.Message.getWrapperField(this, shared_types_physical_address_pb.PhysicalAddress, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.PhysicalAddress|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.prototype.setMailingAddress = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.prototype.clearMailingAddress = function() {
  return this.setMailingAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.CheckTaxRefundDeliveryMethod.prototype.hasMailingAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankAccount: (f = msg.getBankAccount()) && proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod;
  return proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.deserializeBinaryFromReader);
      msg.setBankAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional BankAccountDetails bank_account = 1;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails}
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.prototype.getBankAccount = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails, 1));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.prototype.setBankAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.prototype.clearBankAccount = function() {
  return this.setBankAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.DirectDepositTaxRefundDeliveryMethod.prototype.hasBankAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod;
  return proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.FutureTaxCreditTaxRefundDeliveryMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
    routingNumber: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails;
  return proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountType} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoutingNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoutingNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional BankAccountType account_type = 1;
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountType}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.getAccountType = function() {
  return /** @type {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountType} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string routing_number = 3;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.getRoutingNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountDetails.prototype.setRoutingNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest;
  return proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.GetTaxRefundMethodRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest;
  return proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.GetPersonalTaxRefundMethodForJobRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest;
  return proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.GetBusinessTaxRefundMethodForJobRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ownerUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    refundType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    deliveryMethod: (f = msg.getDeliveryMethod()) && proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest;
  return proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType} */ (reader.readEnum());
      msg.setRefundType(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.deserializeBinaryFromReader);
      msg.setDeliveryMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOwnerUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRefundType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDeliveryMethod();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string owner_user_id = 2;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.getOwnerUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.setOwnerUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TaxRefundType refund_type = 3;
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.getRefundType = function() {
  return /** @type {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.setRefundType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional TaxRefundDeliveryMethod delivery_method = 4;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.getDeliveryMethod = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod, 4));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.setDeliveryMethod = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.clearDeliveryMethod = function() {
  return this.setDeliveryMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodRequest.prototype.hasDeliveryMethod = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse;
  return proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.CreateTaxRefundMethodResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deliveryMethod: (f = msg.getDeliveryMethod()) && proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest;
  return proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod;
      reader.readMessage(value,proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.deserializeBinaryFromReader);
      msg.setDeliveryMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeliveryMethod();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TaxRefundDeliveryMethod delivery_method = 2;
 * @return {?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.getDeliveryMethod = function() {
  return /** @type{?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod, 2));
};


/**
 * @param {?proto.worklayer.internal.tax_refund_methods.v1.TaxRefundDeliveryMethod|undefined} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest} returns this
*/
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.setDeliveryMethod = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.clearDeliveryMethod = function() {
  return this.setDeliveryMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodRequest.prototype.hasDeliveryMethod = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse;
  return proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse} returns this
 */
proto.worklayer.internal.tax_refund_methods.v1.UpdateTaxRefundMethodResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.worklayer.internal.tax_refund_methods.v1.TaxRefundType = {
  TAX_REFUND_TYPE_UNSPECIFIED: 0,
  PERSONAL: 1,
  BUSINESS: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.tax_refund_methods.v1.BankAccountType = {
  BANK_ACCOUNT_TYPE_UNSPECIFIED: 0,
  CHECKING: 1,
  SAVINGS: 2
};

goog.object.extend(exports, proto.worklayer.internal.tax_refund_methods.v1);
